import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";

import { Button } from "../../UI/Button";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { CopyGenderOptionsToOtherSubnetworksModal } from "./CopyGenderOptionsToOtherSubnetworksModal";

interface IProps {
  l2Id: number;
  isDisabled?: boolean;
}

export const AddToOtherSubnetworksButton: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { setIsOpen } = useModalContext();

  const handleClick = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button appearance="primary" onClick={handleClick} isDisabled={!props.l2Id || props.l2Id === 0 || isSuperAdminRead() || props.isDisabled}>
          Apply to other Matching Rounds
        </Button>
      </ReadOnlyWrapper>
      <CopyGenderOptionsToOtherSubnetworksModal l2Id={props.l2Id} />
    </>
  );
};
